import HTTPClient from '@elab/core/utils/HTTPClient';
import apiUtils from '@elab/core/utils/apiUtils';

const getPrefillInformation = async data => {
    let result = false;

    try {
        const uri = `${apiUtils.getBaseUri()}/forms/prefill`;
        const response = await HTTPClient().postJson(uri, data);

        if (!response.ok) {
            throw new Error(`Unable to load address suggestions (${response.status})`);
        }
        result = await response.json();
    } catch (err) {
        /* Nothing */
    }

    return result;
};

export default {
    getPrefillInformation,
};
